import React from "react";
import { StripeAccountFieldSelectTemplate } from "themes/common/components";

function StripeAccountFieldSelect(props) {
    return <StripeAccountFieldSelectTemplate {...props} />;
}

export default StripeAccountFieldSelect;
